import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Home as HomeIcon, ArrowLeft } from "lucide-react";
import { useLang } from "@/i18n";
import { setSeo } from "@/lib/seo";

export default function NotFound() {
  const { t } = useLang();
  useEffect(() => {
    setSeo({ title: "Página no encontrada · Grupo Ritual", description: "La página que buscas no existe.", robots: "noindex, follow", canonical: null });
  }, []);

  return (
    <div className="pt-[72px] min-h-[70vh] flex items-center justify-center px-5" data-testid="not-found">
      <div className="text-center max-w-md">
        <p className="font-display text-7xl sm:text-8xl text-[#1A1514] tracking-tighter">404</p>
        <h1 className="font-display text-2xl text-[#1A1514] mt-4">{t({ es: "Página no encontrada", en: "Page not found", va: "Pàgina no trobada" })}</h1>
        <p className="text-[#5C544F] mt-3">{t({ es: "Puede que el enlace haya cambiado o la página ya no exista.", en: "The link may have changed or the page no longer exists.", va: "Pot ser que l'enllaç haja canviat o la pàgina ja no existisca." })}</p>
        <div className="flex flex-wrap gap-3 justify-center mt-8">
          <Link to="/" data-testid="notfound-home" className="inline-flex items-center gap-2 bg-[#1A1514] text-[#FBF9F6] px-6 py-3 rounded-sm font-medium hover:bg-[#3B2A22] transition-colors">
            <HomeIcon className="w-4 h-4" /> {t({ es: "Ir al inicio", en: "Go home", va: "Anar a l'inici" })}
          </Link>
          <Link to="/tienda" data-testid="notfound-shop" className="inline-flex items-center gap-2 border border-[#E3DCD2] text-[#1A1514] px-6 py-3 rounded-sm font-medium hover:border-[#1A1514] transition-colors">
            <ArrowLeft className="w-4 h-4" /> {t({ es: "Ver la tienda", en: "Visit the shop", va: "Veure la botiga" })}
          </Link>
        </div>
      </div>
    </div>
  );
}
